var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 466,
    viewBox: "0 0 666 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_919_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.333 433.16C666.333 451.48 651.48 466.333 633.16 466.333H366.173C347.853 466.333 333 451.48 333 433.16C333 414.84 347.853 399.987 366.173 399.987H633.16C651.48 399.987 666.333 414.84 666.333 433.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.334 233.007C666.334 251.33 651.48 266.18 633.16 266.18H32.84C14.519 266.18 -0.333008 251.33 -0.333008 233.007C-0.333008 214.687 14.519 199.837 32.84 199.837H633.16C651.48 199.837 666.334 214.687 666.334 233.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.16 66.013C651.48 66.013 666.334 51.1607 666.334 32.8397C666.334 14.5187 651.48 -0.333313 633.16 -0.333313H232.84C214.519 -0.333313 199.667 14.5187 199.667 32.8397C199.667 51.1607 214.519 66.013 232.84 66.013H633.16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_919_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 666,
    height: 466,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.2fd98e5c620a50d03ed2fdc75ef49fad.svg";
export { ForwardRef as ReactComponent };